import React, {Component} from 'react';
import './articletexts.css';

const MAX_SQUARE_WIDTH_FOR_TITLES = 200;
const BREAKPOINT = 576;
class ArticleTexts extends Component {
  constructor(props) {
    super(props);
    this.selected = null;
  }
  showText(id) {
    this.hideText(this.selected);
    this.selected = id;
    this.ul.querySelector(`li#a${id}`).classList.add('highlight');
  }
  hideText(id) {
    //if(id == undefined) {
    if( typeof id === 'undefined' || id === null ){
      return;
    }
    this.ul.querySelector(`li#a${id}`).classList.remove('highlight');
  }
  render() {
    const {width, articles} = this.props;
    // let prevAlignment = null;
    const texts = articles.map(d => {
      const liStyle = {
        top: `${d.position[1] + (width < BREAKPOINT ? d.diag/2 : 0)}px`,
      };

      let visibilityClassName = (d.diag < MAX_SQUARE_WIDTH_FOR_TITLES) ? 'hidden' : 'default';

      let alignment = 'left';
      let x = d.position[0];
      if(width > BREAKPOINT) {
        if( x > 0) {
          liStyle.left = x - d.diag / 2;
          alignment = 'right';
          // if(prevAlignment === 'right' && Math.abs(x) > widthDelta) {
          //   alignment = 'left';
          //   liStyle.left = x + 15 + d.diag / 2;
          // }
        } else {
          liStyle.left = x + 15 + d.diag / 2;
          // if(prevAlignment === 'left' && Math.abs(x) > widthDelta) {
          //   liStyle.left = x - d.diag / 2;
          //   alignment = 'right';
          // }
        }
        liStyle.left = Math.round(liStyle.left);
      }

      // if(visibilityClassName === 'default') {
      //     prevAlignment = alignment;
      // }
      visibilityClassName = 'hidden';

      const slugs = d.slugs.map(slug => {
        return <li key={slug} className={slug}>{slug}</li>
      })
      return (
        <li key={d.article.id} id={`a${d.article.id}`} style={liStyle} className={`article-text ${alignment}-align ${visibilityClassName}`}>
          <div>
            <span className="article-date">{d.article.short_published}</span>
            <span className="article-source">{d.article.source}</span>
            <h2><a href={d.article.url} title="Apri articolo" target="_blank">{d.article.title}</a></h2>
            <ul className="article-slugs">{slugs}</ul>
            <a href={d.article.url} target="_blank" className="read-more">Leggi &raquo;</a>
          </div>
        </li>
      );
    });

    return <ul ref={el => this.ul = el} className="article-texts">{texts}</ul>
  }

}

export default ArticleTexts;



// WEBPACK FOOTER //
// ./src/elezioni/components/Layout/ArticleTexts.js